import { useTranslation } from 'react-i18next';
import { PlaneTakeoff, PlaneLanding } from 'lucide-react';
import type { ColumbusPlannerTicketModel } from '@/api/generated/schemas';

interface Props {
  tickets: ColumbusPlannerTicketModel[];
}

function TicketsTable({
  tickets,
  isDeparture,
}: {
  tickets: ColumbusPlannerTicketModel[];
  isDeparture: boolean;
}) {
  const { t } = useTranslation('columbus-planner');
  return (
    <table className="text-xs whitespace-nowrap">
      <thead>
        <tr className="text-right">
          <th className="text-phx-text-muted px-2 py-0.5 text-left font-semibold">
            {isDeparture ? (
              <PlaneTakeoff className="h-3 w-3" />
            ) : (
              <PlaneLanding className="h-3 w-3" />
            )}
          </th>
          <th className="text-phx-text-muted px-2 py-0.5 font-semibold">{t('tickets.paxUsed')}</th>
          <th className="text-phx-text-muted px-2 py-0.5 font-semibold">{t('tickets.cost')}</th>
        </tr>
      </thead>
      <tbody>
        {tickets.length === 0 && (
          <tr className="border-t border-solid border-t-indigo-200 bg-indigo-100 text-right dark:border-t-indigo-800 dark:bg-indigo-950">
            <td className="px-2 py-px" colSpan={3}>
              {t('tickets.noTickets')}
            </td>
          </tr>
        )}
        {tickets.map((t, idx) => (
          <tr
            key={idx}
            className={`border-t border-solid border-t-indigo-200 text-right dark:border-t-indigo-800 ${
              idx % 2 === 0
                ? 'bg-indigo-100 dark:bg-indigo-950'
                : 'bg-indigo-50 dark:bg-indigo-900/40'
            }`}
          >
            <td className="px-2 py-px text-left">{t.code}</td>
            <td className="px-2 py-px">
              {t.count} / {t.assigned}
            </td>
            <td className="px-2 py-px">{t.cost}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function TicketsList({ tickets }: Props) {
  const depTickets = tickets.filter((t) => t.isDeparture);
  const retTickets = tickets.filter((t) => !t.isDeparture);

  return (
    <div className="mt-4 mb-2 flex space-x-5">
      <TicketsTable tickets={depTickets} isDeparture={true} />
      <TicketsTable tickets={retTickets} isDeparture={false} />
    </div>
  );
}
